<template>
  <div class="review__stars">
    <IconComponent v-for="i in starLimit" :key="i" name="star-fill" />
    <div
      :style="{ width: ((parseFloat(mark) / starLimit) * 100).toFixed() + '%' }"
      class="review__stars review__stars--filled"
    >
      <IconComponent v-for="i in starLimit" :key="i" name="star-fill" />
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "ReviewMarkComponent",
  props: {
    mark: {
      type: [Number, String],
      default() {
        return 0;
      },
    },
    starLimit: {
      type: Number,
      default() {
        return 5;
      },
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
// ширина и высота иконок звездочек
width = 18px
height = 18px

.review__stars {
  position relative
  display flex

  .icon {
    width width
    height height
    margin: 0 2px

    svg path {
      stroke none
      fill var(--gray)
    }
  }

  &--filled {
    position absolute
    left 0
    top 0
    width 0
    overflow hidden

    .icon svg path {
      stroke none
      fill var(--yellow)
    }
  }
}
</style>
